import React, { useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useNewsContext } from "@/features/news/contexts/news-context";
import { usePostNews } from "@/features/news/hooks/use-post-news";

interface Props {
  onTapCloseModal: () => void;
}

// お知らせモーダル
export const NewsModal = ({ onTapCloseModal }: Props ) => {
  const {
    news,
    setNews,
  } = useNewsContext();
  const { postNews } = usePostNews();

  const [readNrcodeList, setReadNrcodeList] = useState<string[]>([]);

  const handleClose = async () => {
    if (readNrcodeList.length > 0) {
      await postNews(readNrcodeList);
    }
    onTapCloseModal();
  };

  return (
    <BasePageModal
      title="お知らせ"
      className="info-list"
      handleClose={() => {handleClose()}}
    >
      {news.length === 0 ? (
        <h2>最新のお知らせはありません。</h2>
      ) : (
        <ul>
          {news.map((item) => (
            <li
              key={item.nrcode}
              className={item.check === 0 ? "new" : ""}
            >
              <a
                href={item.linkaddress}
                target="_blank"
                rel="noreferrer"
                onClick={() => {
                  if (item.check === 0) {
                    setReadNrcodeList((prev) => [...prev, item.nrcode]);
                    // コンテキスト上のお知らせ一覧の既読状態を更新
                    setNews((prevNews) =>
                      prevNews.map((newsItem) =>
                        newsItem.nrcode === item.nrcode
                          ? { ...newsItem, check: 1 }
                          : newsItem
                      )
                    );
                  }
                }}
              >
                <span>{item.startdate}</span>
                <strong>{item.title}</strong>
              </a>
            </li>
          ))}
        </ul>
      )}
    </BasePageModal>
  );
};
